<div class="container">
  <div class="row">
    <div class="col-sm-10 col-sm-offset-1">
      <div class="col-sm-12">
        <div class="pull-right">
          <app-language-selector></app-language-selector>
        </div>
      </div>

      <form #formVerifyByOTP="ngForm" name="formVerifyByOTP" (submit)="handleSubmit(formVerifyByOTP.value, $event)"
        novalidate>
        <h3 class="page__heading text-dark-blue margin-bottom-24">
          {{ appCopy.panelHeader["title" + selectedLanguage] }}
        </h3>

        <div class="panel">
          <div class="panel__header">
            {{ appCopy.panelHeader["description" + selectedLanguage] }}
          </div>
          <div class="panel__body">
            <div class="section">
              <p class="text-muted text-dark-blue">
                {{ appCopy.panelHeader["heading" + selectedLanguage] }}
              </p>
            </div>
            <div class="section section__colored">
              <div class="form-group">
                <input class="form-control" [ngClass]="{ 'has-error': email.invalid && email.dirty }" id="email"
                  name="email" type="email" #email="ngModel" [pattern]="emailPattern" [ngModel]="userEmail" ngModel
                  required appCheckEmpty [placeholder]="appCopy.panelHeader['emailPlaceholder' + selectedLanguage]" readonly/>

                <p class="help-block text-danger" *ngIf="email?.errors?.pattern">
                  {{ appCopy.panelHeader["validEmail" + selectedLanguage] }}
                </p>
                <p class="help-block text-danger" *ngIf="
                    email.invalid && email.dirty && !email?.errors?.pattern
                  ">
                  {{ appCopy.panelHeader["warningEmail" + selectedLanguage] }}
                </p>
              </div>

              <div class="form-group margin-top-16" *ngIf="showEmailSent">
                <input class="form-control" [ngClass]="{ 'has-error': otp.invalid && otp.dirty }" id="Otp" name="otp"
                  type="otp" #otp="ngModel" ngModel alert-caps-lock required appCheckEmpty maxlength="6" pattern="\d{6}"
                  [placeholder]="appCopy.panelHeader['OTPPlaceholder' + selectedLanguage]" />
                <i class="icon control-validation-state"></i>

                <p class="help-block text-danger" *ngIf="otp.invalid && otp.dirty && !otp?.errors?.pattern">
                  {{ appCopy.panelHeader["warningOTP" + selectedLanguage] }}
                </p>

                <p class="help-block text-danger" *ngIf="otp?.errors?.pattern">
                  {{ appCopy.panelHeader["validOTP" + selectedLanguage] }}
                </p>
              </div>
            </div>
            <div class="section section__actions flex flex--justify-content-center text-center gap-16">
              <ng-template [ngIf]="showEmailSent" [ngIfElse]="otpNotSent">
                <button type="submit" class="btn btn-purple btn-lg" [disabled]="formVerifyByOTP.invalid">
                  <div class="loader-container-btn" *ngIf="showLoader">
                    <div class="loader loader--white">
                      <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" />
                      </svg>
                    </div>
                  </div>
                  {{ appCopy.panelHeader["submitOTPButton" + selectedLanguage] }}
                </button>

                <button (click)="resendEmail($event)" class="btn btn-primary btn-ghost btn-lg"
                  [disabled]="
                    showLoader ||
                    isCounting ||
                    (email.invalid && email.dirty && !email?.errors?.pattern)
                  ">
                  {{ isCounting ? appCopy.panelHeader['resendInSecText'+selectedLanguage].replace('%s', countdown) :
                  appCopy.panelHeader['resendOTPButton'+selectedLanguage] }}
                </button>
              </ng-template>

              <ng-template #otpNotSent>
                <!-- <p class="text-muted text-dark-blue margin-bottom-24">
                  {{ appCopy.panelHeader["ifNewUseOTPText" + selectedLanguage] }}
                </p> -->

                <button type="submit" class="btn btn-purple btn-lg" [disabled]="formVerifyByOTP.invalid">
                  <div class="loader-container-btn" *ngIf="showLoader">
                    <div class="loader loader--white">
                      <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" />
                      </svg>
                    </div>
                  </div>
                  {{ appCopy.panelHeader["sendOTPButton" + selectedLanguage] }}
                </button>
              </ng-template>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
